import { createSlice } from '@reduxjs/toolkit';

import { fetchSettings, togglePreloading } from './setting';
import { request } from '../../services/http';
import { USER_API } from '../../services/api';

export const fetchAuthUser = () => async dispatch => {
	try {
		const rs = await request(USER_API);
		const { user, auth } = rs.result;
		const permissions = user.roles.reduce(
			(permissions, item) => [...permissions, ...item.permissions],
			[]
		);
		dispatch(loginUser(user));
		dispatch(setAuthMethod(auth));
		dispatch(setPermissions(permissions));
		dispatch(togglePreloading(false));
		dispatch(fetchSettings());
	} catch (e) {
		dispatch(signOut());
		dispatch(togglePreloading(false));
	}
};

const initialState = {
	user: null,
	auth_method: null,
	loggedIn: false,
	permissions: [],
	connected: false,
	onlineUsers: [],
};

export const accountSlice = createSlice({
	name: 'account',
	initialState,
	reducers: {
		loginUser: (state, action) => {
			state.user = action.payload;
			state.loggedIn = true;
		},
		setUser: (state, action) => {
			state.user = action.payload;
		},
		setAuthMethod: (state, action) => {
			state.auth_method = action.payload;
		},
		setPermissions: (state, action) => {
			state.permissions = action.payload;
		},
		signOut: () => {
			return initialState;
		},
		setConnected: (state, action) => {
			state.connected = action.payload;
		},
		setOnlineUsers: (state, action) => {
			state.onlineUsers = action.payload;
		},
	},
});

export const {
	loginUser,
	setUser,
	setPermissions,
	signOut,
	setConnected,
	setOnlineUsers,
	setAuthMethod,
} = accountSlice.actions;

export default accountSlice.reducer;
